@use '../../styling/typography.scss' as *;

.MultiCheckbox {
  @extend %font-family-primary;

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  li:not(:last-child) {
    margin-bottom: 7px;
  }
}
